import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Link} from 'react-router-dom'
import {IPost} from '../../../models/Post'
import {postCategoryMessages} from '../../config/commonMessages'
import {getPostUrl} from '../../helpers/post'
import ImageContainer from '../containers/ImageContainer'
import ResponsiveImg from '../common/ResponsiveImg'
import {useAmp} from '../hocs/hooks'
import styles from './PostThumbnail.scss'

const PostThumbnailSp = ({post}: {post: IPost, className?: string}) => {
  const {
    photo,
    title,
    categories: [category],
  } = post
  const amp = useAmp()
  return <div className={['mb-3', styles.container, styles.containerSp].join(' ')}>
    <div className="overflow-hidden">
      <ImageContainer>
        <Link to={getPostUrl(post, false, amp)}
              className={styles.imgWrapper}>
          <ResponsiveImg
            noContainer
            url={photo}
            caption={title}
            className={styles.photo}
          />
        </Link>
      </ImageContainer>
    </div>
    <div className={['m-2 pb-1 text-left', styles.content].join(' ')}>
      {category && <div className="text-gray font-weight-medium small mb-1">
        <FormattedMessage {...postCategoryMessages[category]}/>
      </div>}
      <Link to={getPostUrl(post, false, amp)}
            className={['font-weight-bold ellipsis text-black', styles.title].join(' ')}>
        {title}
      </Link>
    </div>
  </div>
}
PostThumbnailSp.displayName = 'PostThumbnailSp'
export default PostThumbnailSp

export const PostThumbnailListSp = ({posts}: {posts: ReadonlyArray<IPost>}) => {
  return <>
    {posts.length
      ? posts.map(post => <PostThumbnailSp post={post} key={post._id}/>)
      : <div className="text-center">
        <FormattedMessage id="post.noPost"/>
      </div>
    }
  </>
}
PostThumbnailListSp.displayName = 'PostThumbnailListSp'
